import React from 'react';
import { SectionLabel } from './SectionLabel';
import { Bloom } from './Bloom';
import { DeviceMockup } from './visuals/DeviceMockup';
const points = ['Answers calls 24/7, including nights, weekends, and the middle of a job.', 'Texts back the ones you miss in seconds, while they are still holding the phone.', 'Books estimates straight onto your calendar instead of taking a message.', 'Built and tuned with you on a setup call: your services, your area, your words.'];
const callLines = [{
  from: 'caller' as const,
  text: "Hi, is anyone able to come look at a leak today?"
}, {
  from: 'ai' as const,
  text: "Yes, I can get someone out this afternoon. What's the address?"
}, {
  from: 'caller' as const,
  text: "1420 E Palm Ln, Phoenix"
}, {
  from: 'ai' as const,
  text: "Got it. I have a 2:00pm opening, does that work?"
}];
export function AIReceptionist() {
  return <section className="relative isolate overflow-hidden border-b border-[#1a1a1a]" data-id="element-146" data-mp="i143fsbtu2jc">
      <Bloom size="md" className="right-0 top-[-8rem]" data-id="element-147" data-mp="21o1c0causl88" />
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-14 px-6 py-20 lg:grid-cols-2 lg:py-24" data-id="element-148" data-mp="21pm7q58wma7o">
        <div data-id="element-149" data-mp="1wr18a81h7uka">
          <SectionLabel data-id="element-150" data-mp="1rpvcg1cirr6j">AI receptionist</SectionLabel>
          <h2 className="mt-8 text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-151" data-mp="1rqmyolk88ck5">
            Somebody picks up. Even when nobody can.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-neutral-400" data-id="element-152" data-mp="2kf28mtoi44om">
            It talks to the caller, answers what you told it to answer, and puts the estimate on
            your calendar.
          </p>
          <ul className="mt-8 space-y-4" data-id="element-153" data-mp="2anxyc79rt804">
            {points.map(p => <li key={p} className="flex gap-3 text-sm leading-relaxed text-neutral-300" data-id="element-154" data-mp="25pwa77xhmihs">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-500" aria-hidden="true" data-id="element-155" data-mp="334qp5hrlvikg" />
                {p}
              </li>)}
          </ul>
        </div>
        <div className="order-first lg:order-none" data-id="element-156" data-mp="wi2tzqd53boc">
          <DeviceMockup mode="call" heading="Incoming call" lines={callLines} resultChip="Booked to calendar, Tue 2:00 PM" data-id="element-157" data-mp="11fuvnc3l6c5q" />
        </div>
      </div>
    </section>;
}